module.exports = __webpack_public_path__ + "img/g_02.95393505.png";